import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_190: DocMigration = {
  maxSchemaVersion: "0.0.190",
  description: "Update foundation condition labels in settings to replace 'INTERIOR to 'HOUSE'",

  apply(json: any) {
    //2. change foundation condition labels to map 'INTERIOR' sub-string to 'HOUSE'
    //update foundation settings
    if (json.settings) {
      const allSettingsIds = Object.keys(json.settings);
      for (const settingId of allSettingsIds) {
        const setting = json.settings[settingId];

        if (setting.type === "FOUNDATION_SETTINGS") {
          const hash = setting.foundationHash;
          if (!hash) {
            continue;
          }

          const systemSetting = setting[hash];

          if (!systemSetting) {
            continue;
          }

          const foundationConditions = systemSetting.foundationConditions ?? undefined;

          if (foundationConditions) {
            systemSetting.foundationConditions = Object.keys(systemSetting.foundationConditions).reduce(
              (acc, key) => ({
                ...acc,
                ...{
                  [key.includes("INTERIOR") ? key.replace(/INTERIOR/g, "HOUSE") : key]:
                    systemSetting.foundationConditions[key],
                },
              }),
              {},
            );
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_190;
